// extracted by mini-css-extract-plugin
export default {"root":"IconRefresh_root__Kuc4e"};